<template>


  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <div class="card gl-container-shadow">
          <div class="card-block">
            <form action="" method="post" class="form-horizontal" @keydown.enter.prevent=''>
              <div class="form-group row gl-actionbar">
                <div class="col-md-3">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <dropdown text="" type="primary">
                        <div slot="dropdown-menu" class="dropdown-menu">
                        <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('all', 'ALL')">ALL</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('branchCode', 'Store code')">Store code</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('address.streetAddress', 'Street Address')">Street Address</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('address.addressLocality', 'City')">City</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('address.addressRegion', 'State')">State</a>
                        </div>
                      </dropdown>
                    </div>
                    <input type="text"  v-model="searchText" id="input1-group3" name="input1-group3" class="form-control" :placeholder="`Search By ${criterion[0].toUpperCase() + criterion.slice(1)}`" @input="didUpdateSearchTerm">
                    &nbsp;
                    <span id="searchclear"class="fa fa-remove" @click="clearSearch()">&nbsp;</span>
                  </div>
                </div>
                <div class="col-md-3">
                 <loader v-if="loadingDatabase" label='Loading Database' />
                </div>
                <div class="col-md-6"><div  class="pull-right">
                  <div v-if="removeActive">
                    <button v-if="hasOrganization" type="button" class="btn btn-info" v-on:click="didEditSelectedLocations"><i class="fa fa-edit"></i> Edit Selected Locations {{selectedEntities.length}} </button>
                    <button v-if="hasOrganization && !publishing" type="button" class="btn btn-danger" v-on:click="didSelectRemoveLocations"><i class="fa fa-close"></i> Remove Selected Locations {{selectedEntities.length}}</button>
                    <button v-if="hasOrganization" type="button" class="btn btn-primary ml-3" v-on:click="addNewLocation"><i class="fa fa-plus"></i>&nbsp;&nbsp;New</button>
                  </div>
                  <div v-else>
                    
                    <button v-if="hasOrganization && publishing" type="button" class="btn btn-outline-primary disabled" aria-disabled="true"><i class="fas fa-circle-notch fa-spin"></i> Publishing </button>
                    <button v-if="hasOrganization && !publishing" type="button" class="btn btn-primary" v-on:click="checkDeployData('pages')"><i class="fa fa-database"></i>&nbsp;&nbsp;Publish</button>
                    <button v-if="hasOrganization || publishing" type="button" class="btn btn-outline-danger disabled" aria-disabled="true"><i class="fa fa-close"></i> Remove Selected Locations</button>
                    <button v-if="hasOrganization" type="button" class="btn btn-primary" v-on:click="addNewLocation"><i class="fa fa-plus"></i>&nbsp;&nbsp;New</button>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <table class="table table-bordered table-responsive gl-table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" class="form-check-input" @change="toggleCheckAll()" :checked="selectedAllChecked" style="margin-top:10px; z-index:999"  />
                  <dropdown id="select-all-drop"   >
                    <div slot="dropdown-menu" class="dropdown-menu" style="width: 10px">
                      <a href="#" v-html="selectedPageLabel" v-on:click="updateSelectCriterion('page')" class="dropdown-item"></a>
                      <a href="#" v-html="selectedAllLabel" v-on:click="updateSelectCriterion('all')" class="dropdown-item"></a>
                    </div>
                  </dropdown>
                 </th>
                <th>Store code</th>
                <th>Street Address</th>
                <th>City</th>
                <th>State</th>
                <th style="text-align: center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hasOrganization">
                <td colspan="5" class="text-center pt-5 pb-5">
                  <h3>Welcome to your GetLocal Dashboard</h3>
                  <div>You will receive a notification when your location information is available.</div>
                </td>
              </tr>
              <tr v-for="entity in entityList ">
                <td><input type="checkbox" class="form-check-input" @change="toggleCheckLocation(entity)" :checked="entity.checked"></td>
                <th>{{branchCodeLabel(entity.branchCode)}}</th>
                 <th>{{entity.address.streetAddress}}</th>
                 <th>{{entity.address.addressLocality}}</th>
                 <th>{{entity.address.addressRegion}}</th>
                <td class="text-center"><!-- <router-link :to="{name : 'EditLocation', params : { branchCode: location.branchCode, fbKey : location['.key']}}">Edit</router-link> -->
                  <button type="button" class="btn btn-primary" v-on:click="edit(entity.id)"><i class="fa fa-edit"></i> Edit</button>
                </td>
              </tr>
            </tbody>
          </table>

          <nav aria-label="Page navigation example" v-if="hasOrganization"class="pagination-container">
            <ul class="pagination">
              <li><a href="#" class="first" v-on:click="clickedPage(1)">First</a></li>
              <li><a href="#" class="left" v-on:click="clickedPreviousPage"><</a></li>
              <li v-for="page in pages" v-bind:class="{active: page === currentPage + 1}">
                <a href="#" v-on:click="clickedPage(page)">{{page}}</a>
              </li>
              <li><a href="#" class="right" v-on:click="clickedNextPage">></a></li>
              <li><a href="#" class="last" v-on:click="clickedPage(pages.length)">Last</a></li>
            </ul>
          </nav>

        </div>
      </div>
    </div><!--/.col-->
  </div><!--/.row-->
  <modal title="Modal title" class="modal-danger" v-model="dangerModal" @ok="removeSelectedLocations" effect="fade/zoom">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">Are you sure you want to delete these Locations?</h4>
    </div>
    This cannot be undone.
  </modal>
  <modal title="Modal title" class="modal-danger" v-model="deployModal" @ok="deployData" cancel-text='Cancel' ok-text='Start Deployment' effect="fade/zoom">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">Are you sure you want to Publish the Locations?</h4>
    </div>
  </modal>
  <alert :show.sync="showTop" v-model="showTop" placement="top" duration="3000" number="0" type="success" width="380px" dismissable style="margin-top: 20px;">
    <span class="icon-info-circled alert-icon-float-left"></span>
    <strong>Success</strong>
    <p>Your changes have seen saved!</p>
  </alert>
  <alert :show.sync="showInlineDeployNotifation" v-model="showInlineDeployNotifation" placement="top" duration="0" number="0" type="success" width="380px" dismissable style="margin-top: 20px;">
    <span class="icon-info-circled alert-icon-float-left"></span>
    <strong>Success</strong>
    <p>Your data has been published!</p>
  </alert>
  <alert :show.sync="showInlineDeployNotifationError" v-model="showInlineDeployNotifationError" placement="top" duration="0" number="0" type="danger" width="380px" dismissable style="margin-top: 20px;">
    <span class="icon-info-circled alert-icon-float-left"></span>
    <strong>Error</strong>
    <p>The publishing job failed!</p>
  </alert>
</div>

</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { dropdown } from "vue-strap";
import modal from "vue-strap/src/Modal";
import { alert } from "vue-strap";
import loader from "./widgets/loader.vue"
import axios from 'axios'
import { db } from '../../firebase'
import VueNativeNotification from 'vue-native-notification'

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})

let recordsPerPage = 10;
let totalPages;


export default {
  name: "localbusiness",
  data: function() {
    return {
      loadingDatabase: false,
      dangerModal: false,
      deployModal: false,
      publishing: false,
      deployCheckInterval: '',
      showInlineDeployNotifation: false,
      showInlineDeployNotifationError: false,
      searchText: '',
      searching: false,
      searchCriterion: 'all',
      searchCriterionName: 'ALL',
      showTop: false,
      removeActive: false,
      page: 0,
      listResults: [],
      searchResults: [],
      listChecked: {},
      firebaseNode: 'LocalBusinesses',
      selectedEntities:[],
      selectedPageLabel: "PAGE &#10004;",
      selectedAllLabel: "ALL",
      selectedCriterion: "page",
      selectedAllChecked: false,
      selectedPages:{},
      status: ''
    };
  },
  components: {
    loader,
    modal,
    dropdown,
    alert
  },
  created: function() {
    this.checkDeployStatus('pages')
  },
  mounted: function() {
    this.listResults = []
    this.fetchDatabase()
    this.evalRemoveButton()
    this.searchText = this.$store.getters.searchText
    this.searchCriterion = this.$store.getters.criterion
    this.performSearch()
  },
  updated: function() {
    if (this.$store.state.notification) {
      this.showAlert();
      this.$store.state.notification = false
    }
  },
  methods: {
    branchCodeLabel(val) {
            return val
        },
    fetchDatabase() {
      this.loadingDatabase = true
      const onResult = (results) => { this.listResults = results; this.evalRemoveButton() }
      const onLoadedCallback = (firebaseNode) => {
        this.loadingDatabase = false;
        this.listResults.forEach(item => {
          item.checked = false
        })
        this.evalRemoveButton()
      }
      this.$store.dispatch('fetchDatabase', { firebaseNode: this.firebaseNode,  onFetchResult: onResult, onLoadedCallback: onLoadedCallback })
    },
    clickedPage(cpage) {
      //console.log('clicked page: ', cpage);
      this.page = cpage - 1
      this.evalRemoveButton()
      this.evalCheckAllButton()
    },
    clickedPreviousPage() {
      const currentPage = this.currentPage;
      const newPage = currentPage === 0 ? 0 : currentPage - 1;
      this.page = newPage
      this.evalRemoveButton()
      this.evalCheckAllButton()
    },
    clickedNextPage() {
      const currentPage = this.currentPage;
      const totalPages = Math.ceil(this.listResults.length / parseFloat(recordsPerPage));
      const newPage = currentPage === totalPages - 1 ? totalPages - 1 : currentPage + 1;
      this.page = newPage
      this.evalRemoveButton()
      this.evalCheckAllButton()
    },
    edit(entityId) {
      this.$router.push({ name: "EditLocalBusiness", params: { organization: this.$store.getters.organization.id, entityId: entityId } });
    },
    didUpdateSearchTerm(e) {
        this.page = 0
        if (e != null) {
          this.searchText = e.target.value
        }
        this.$store.dispatch('updateSearchText', this.searchText)
        this.performSearch()
    }, 
    performSearch() {
      
        this.searching = true
        let queryConfig = this.$store.getters.searchConfig(this.firebaseNode, this.searchCriterion)
        const results = this.$store.getters.searchIndex(this.firebaseNode).search(this.searchText, queryConfig)
        const map = this.$store.getters.firebaseDataMap(this.firebaseNode)
        this.searchResults = _.map(results, (item) => {
            return map[item.ref]
        })
        this.searching = false
        this.evalRemoveButton()
      },
    toggleCheckLocation(item) {
      if (item.checked === undefined) {
        item.checked = true
      } else {
        item.checked = !item.checked
      }
      this.evalRemoveButton()
    },
    updateSearchCriterion(criterion, name) {
      this.searchCriterion = criterion
      this.searchCriterionName = name
       this.$store.dispatch('updateSearchCriterion', this.searchCriterion)
      this.didUpdateSearchTerm(null)
      this.evalRemoveButton()
    },
    didEditSelectedLocations() {
      console.log(this.selectedEntities)
      if (this.selectedEntities.length > 1) {
        this.$router.push({ name: "EditBatchLocalBusiness", params: { organization: this.$store.getters.organization.id, selectedEntities: this.selectedEntities } });
      } else {
        this.$router.push({ name: "EditLocalBusiness", params: { organization: this.$store.getters.organization.id, entityId: this.selectedEntities[0].id } });
      }
    },
    didSelectRemoveLocations() {
      // console.log('didSelectRemoveStores');
      this.dangerModal = !this.dangerModal;
    },
    addNewLocation() {
      this.$router.push( { name: 'NewLocalBusiness', params: { organization: this.$store.getters.organization.id } } )
    },
    checkDeployData() {
      this.deployModal = !this.deployModal;
    },
    deployData() {
      let self = this
      const url = 'https://eztt6ned80.execute-api.us-east-1.amazonaws.com/staging/raptorStagingDashboardService'
      axios.post(url, {
        'accessToken': self.$store.getters.accessToken,
        'clientSlug': self.$store.getters.organization.id,
        'job': 'localbusiness'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(function (response) {
        console.log(response)
        console.log('SUCCESS ON CALL')
        let type = "page"
        let payload = {'type': type, 'publishing': true}
        self.$store.dispatch('updatePublishingData', payload)
        setTimeout(
          self.checkDeployStatus('pages'),
          10)
        self.deployModal = !self.deployModal
      })
      .catch(function (error) {
        console.log(error)
        self.deployModal = !self.deployModal;
        self.checkDeployStatus('pages')
      })
    },
    checkDeployStatus(type) {
      console.log('checking the deployment status')
      console.log('/Organizations/' + this.$store.getters.organization.id + '/additionalProperties/0/value/' + type + '/jobStatus/status')
      const dbRef = db.ref('/Organizations/' + this.$store.getters.organization.id + '/additionalProperties/')
      let properties;
      dbRef.once('value').then(snapshot => {
        properties = snapshot.val()

        // find job we want to update and change status and updatedAt
        for (let i = 0; i < properties.length; i++) {
          if (properties[i].propertyId === "publish") {
            console.log(type)
            console.log(properties[i].value[type])
            this.status = properties[i].value[type].jobStatus.status
            break
          }
        }
        if (this.status != null && this.status != '') {
          console.log('GOT A STATUS: ' + this.status)
          let currentDeploying = (this.status != 'SUCCEEDED' && this.status != 'FAILED') // val should be the RUNNING state
          if (!this.publishing && currentDeploying) {
            console.log('started')
            let payload = {'type': type, 'publishing': true}
             this.$store.dispatch('updatePublishingData', payload)
            this.startDeploymentStatusCheck()
          } else if (this.publishing && !currentDeploying){
            console.log('stopped')
            let payload = {'type': type, 'publishing': false}
            this.$store.dispatch('updatePublishingData', payload)
            this.evalRemoveButton()
            this.stopDeploymentStatusCheck()
          } else {
            console.log('neither')
          }
          this.publishing = currentDeploying
        } else {
          this.publishing = false
          console.log('DIDNT GET STATUS')
        }
      })
    },
    startDeploymentStatusCheck() {
      this.$notification.requestPermission().then(() => {})
      console.log('called start')
      this.deployCheckInterval = setInterval( () => {
        this.checkDeployStatus('pages')
      }, 10000)
    },
    
    stopDeploymentStatusCheck() {
      if (this.deployCheckInterval && this.deployCheckInterval != '') {
        if (this.status == 'SUCCEEDED') {
          this.$notification.show('GetLocal Dashboard', {
              body: 'Publish Completed!'
          }, {})
          this.showInlineNotification()
        } else {
          this.$notification.show('GetLocal Dashboard', {
              body: 'Publish Failed'
          }, {})
          this.showInlineNotificationError()
        }
        clearInterval(this.deployCheckInterval)
      }
    },
    removeSelectedLocations() {
      // console.log('removing locations....');
      this.selectedEntities = _.filter(this.listResults, entity => { return (entity.checked)?entity.checked:false });
      _.each(this.selectedEntities, entity => {
          this.$store.commit('removeItem',
          {
            firebaseNode: this.firebaseNode,
            item: entity,
          })
      });
      this.clearSearch()
      this.dangerModal = !this.dangerModal;
      this.evalRemoveButton()
    },
    clearSearch() {
      this.page = 0
      this.searchCriterion = "all"
      this.searchText = ""
      this.evalRemoveButton()
    },
    showAlert() {
      this.showTop = true
      var self = this;
    },
    showInlineNotification() {
      this.showInlineDeployNotifation = true
    },
    showInlineNotificationError() {
      this.showInlineDeployNotifationError = true
    },
    evalRemoveButton() {
      this.selectedEntities = _.filter(this.listResults, entity => { return (entity.checked)?entity.checked:false });
      if (this.selectedEntities && this.selectedEntities.length > 0 && !this.publishing) {
        this.removeActive = true
      } else {
        this.removeActive = false
      }
      // console.log(this.removeActive)
    },
    evalCheckAllButton() {
      if (this.selectedCriterion == "page") {
        let pageSelected = this.selectedPages["page"+ this.page]
        if (!pageSelected) {
          this.selectedPages["page"+ this.page] = false
        }
        this.selectedAllChecked = this.selectedPages["page"+ this.page]
        this.entityList.forEach(item => {
          item.checked = this.selectedAllChecked
        })
      } else {
        this.listResults.forEach(item => {
          item.checked = this.selectedAllChecked
        })
      }
    },
    updateSelectCriterion(type) {
      if (this.searchText.trim().length > 0) {
        type = "page"
      }
      if (type == "page") {
        this.selectedPageLabel = "PAGE &#10004;"
        this.selectedAllLabel = "ALL"
        this.selectedAllChecked = false
        this.selectedPages = {}
      } else {
        this.selectedPageLabel = "PAGE"
        this.selectedAllLabel = "ALL &#10004;"
        this.selectedAllChecked = false
      }
     this.listResults.forEach(item => {
        item.checked = this.selectedAllChecked
      })
      this.selectedCriterion = type
      this.toggleCheckAll(true)

    },
    toggleCheckAll(force) {
      if (force) {
        this.selectedAllChecked = force
        if (this.selectedCriterion == "page") {
          this.selectedPages["page"+ this.page] = force
        }  
      } else {
        if (this.selectedCriterion == "page") {
          let pageSelected = this.selectedPages["page"+ this.page]
          if (!pageSelected) {
            this.selectedPages["page"+ this.page] = true
          } else {
            this.selectedPages["page"+ this.page] = false
          }
          this.selectedAllChecked = this.selectedPages["page"+ this.page]
        } else {
          this.selectedAllChecked = !this.selectedAllChecked
        }
      }
      
      this.evalCheckAllButton()
      this.evalRemoveButton()
    },
  },
  computed: {
    entityList: function() {
      if (this.searchText.trim().length > 0) {
        return this.searchResults
      }
      const start = this.currentPage * recordsPerPage;
      return this.listResults.slice(start, start + recordsPerPage);
    },
    pages: function() {
      if (this.searchText.trim().length > 0) {
        return 1
      }
      const length = Math.ceil(this.listResults.length / parseFloat(recordsPerPage));
      const pages = Array(length).fill().map((e,i)=>i+1);
      // console.log('pages::', pages);
      return pages;
    },
    currentPage: function() {
      return this.page;
    },
    criterion: function() {
      return this.searchCriterionName;
    },
    hasOrganization: function() {
      return true;
    }
  }
};
</script>

  <style>
#searchclear {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  height: 12px;
  margin: auto;
  font-size: 12px;
  cursor: pointer;
  color: #888888;
  z-index: 1000;
}

th {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #eceff1;
  border-bottom: 1px solid #cfd8dc;
}
.pagination {
  flex-flow: row wrap;
}

.pagination li {
  display: none;
}

.pagination li:nth-of-type(-n + 2),
.pagination li:nth-last-child(-n + 2),
.pagination li.active,
.pagination li.active + li,
.pagination li.active + li + li {
  display: list-item;
}
#select-all-drop button {
  margin-left: 20px;
  padding: 2px 2px 0px 0px;
  background-color: #eceff1;
}
</style>



// WEBPACK FOOTER //
// ListLocalBusiness.vue?13dafa74